import { useState, useRef } from "react";
import EnrichmentModal from "@/pages/manchester/EnrichmentModal";
import useAddressAutocomplete from "@/hooks/useAddressAutocomplete";

export default function HeroSection() {
  const [address, setAddress] = useState("");
  const [showModal, setShowModal] = useState(false);
  const addressInputRef = useRef(null);

  const handleGetStarted = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  // Google autocomplete on hero address input
  useAddressAutocomplete(addressInputRef, (addr) => setAddress(addr));

  return (
    <section id="ts-hero" style={{
      position: "relative",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      paddingTop: "clamp(110px, 14vw, 160px)",
      paddingBottom: 0,
      paddingLeft: "clamp(16px, 5vw, 40px)",
      paddingRight: "clamp(16px, 5vw, 40px)",
      backgroundColor: "#F4F1E7",
      overflow: "hidden",
      boxSizing: "border-box",
    }}>

      {/* Hero background image */}
      <div style={{
        position: "absolute",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundImage: "url(https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/aa111f18e_Apt306Graphene-Airbnb-13.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        zIndex: 0,
      }} />
      {/* Dark overlay for text legibility */}
      <div style={{
        position: "absolute",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.55)",
        zIndex: 1,
      }} />

      <div className="hero-content" style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 2, width: "100%", textAlign: "center", boxSizing: "border-box", transform: "translateY(-3vh)" }}>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", color: "rgba(255,255,255,0.85)", marginBottom: 16, marginTop: 0 }}>
          Airbnb &amp; Short-Let Management
        </p>

        <h1 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: "clamp(38px, 5.2vw, 68px)", lineHeight: 1.05, letterSpacing: "-0.035em", color: "#fff", margin: "0 auto 24px", maxWidth: 900 }}>
          The Home of High&nbsp;<br className="hero-h1-break" />Performing Short-lets.
        </h1>

        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "clamp(16px, 2vw, 20px)", fontWeight: 400, color: "rgba(255,255,255,0.9)", lineHeight: 1.65, maxWidth: 760, margin: "0 auto 32px" }}>
          Fully managed Airbnb &amp; short-let service across the UK. Earn 40-80% more than traditional rent, hands-free, from just 12% + VAT.
        </p>

        <div className="hero-form-wrap" style={{ display: "inline-flex", position: "relative", width: "100%", maxWidth: 650, justifyContent: "center", alignItems: "stretch", boxSizing: "border-box" }}>
        <form
          onSubmit={handleGetStarted}
          style={{ display: "inline-flex", alignItems: "center", background: "#fff", border: "1.5px solid #E0DDD9", borderRadius: 10, padding: "6px 6px 6px 24px", boxShadow: "0 4px 24px rgba(0,0,0,0.07)", maxWidth: 520, width: "100%", position: "relative", zIndex: 2, boxSizing: "border-box" }}
        >
          <input
            ref={addressInputRef}
            type="text"
            value={address}
            onChange={e => setAddress(e.target.value)}
            placeholder="Enter your property address"
            autoComplete="off"
            style={{ flex: 1, border: "none", outline: "none", fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#333", background: "transparent", minWidth: 0, width: "100%", boxSizing: "border-box" }}
          />
          <button
            type="submit"
            style={{ background: "#CD533B", color: "#fff", border: "none", borderRadius: 7, padding: "12px 16px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, transition: "background 0.2s", gap: 8 }}
            onMouseEnter={e => e.currentTarget.style.background = "#B8462F"}
            onMouseLeave={e => e.currentTarget.style.background = "#CD533B"}
            aria-label="Get free rental estimate"
          >
            <span className="btn-text" style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, fontWeight: 600 }}>Get Valuation</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </button>
        </form>
        <div className="hero-trust-badge" style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.35)", borderRadius: "0 10px 10px 0", marginLeft: -15, paddingLeft: 15, paddingRight: 15, position: "relative", zIndex: 1, flexShrink: 0 }}>
          <img
            src="https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/9e7bc089f_Streo_Ad_-_260_x_200__5_.png"
            alt="Trusted by leading booking platforms including Airbnb, Booking.com and Vrbo"
            style={{ height: 45, maxWidth: 108, width: "auto", display: "block", objectFit: "contain", marginLeft: 6 }}
          />
        </div>
        </div>

        <div style={{ marginBottom: 40 }} />
      </div>

      <div className="hero-trust" style={{ position: "relative", zIndex: 2, textAlign: "center", paddingTop: "clamp(28px, 4vw, 40px)", maxWidth: 1200, margin: "0 auto", width: "100%", boxSizing: "border-box" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <div style={{ display: "flex", gap: 2 }}>
            {[1,2,3,4,5].map(i => (
              <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill="#FBBF24" stroke="#FBBF24" strokeWidth="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>
            ))}
          </div>
          <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.9)", fontWeight: 600 }}>5.0 on Google (90+ reviews)</span>
          <span style={{ color: "rgba(255,255,255,0.5)" }}>·</span>
          <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.9)", fontWeight: 600 }}>4.76 on Airbnb (1,000+ reviews)</span>
        </div>
      </div>

      {showModal && (
        <EnrichmentModal
          mode="full"
          baseForm={{ address }}
          onClose={() => setShowModal(false)}
          onSubmitted={() => setShowModal(false)}
        />
      )}

      <style>{`
        @media (max-width: 768px) {
          .btn-text { display: none !important; }
        }
        @media (max-width: 768px) {
          .hero-form-wrap { flex-direction: column !important; align-items: center !important; }
          .hero-trust-badge {
            margin-left: 0 !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
            background: transparent !important;
            border-radius: 0 !important;
            margin-top: 12px !important;
          }
          .hero-trust-badge img { height: 48px !important; max-width: 120px !important; width: auto !important; }
          #ts-hero { min-height: 100dvh !important; display: flex !important; flex-direction: column !important; justify-content: center !important; padding-top: clamp(120px, 16vw, 160px) !important; padding-bottom: 48px !important; box-sizing: border-box !important; }
          .hero-content { transform: none !important; }
        }
        @media (max-width: 768px) {
          #ts-hero h1 { font-size: 34px !important; }
          .hero-h1-break { display: none; }
        }
        @media (min-width: 769px) and (max-width: 1024px) {
          #ts-hero h1 { font-size: clamp(48px, 7vw, 64px) !important; }
        }
        @media (max-width: 480px) {
          #ts-hero { padding-left: 16px !important; padding-right: 16px !important; }
          #ts-hero p { font-size: 14px !important; }
          #ts-hero form { width: 100% !important; max-width: 100% !important; box-sizing: border-box !important; }
          #ts-hero form input { font-size: 16px !important; min-width: 0 !important; }
          #ts-hero form button { min-width: auto !important; padding: 12px 14px !important; }
        }
      `}</style>

    </section>
  );
}